<style scoped>
</style>
<template>
	<div>
		<Table :columns="tableColumn" :data="ChargeDetails"></Table>
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		},
		data() {
			return {
				tableColumn: [{
						title: '充电订单号',
						key: 'ChargeOrderNo',
					}, {
						title: '充电枪编码',
						key: 'ConnectorNo',
					}, {
						title: '插枪时间',
						key: 'PluginsInTime',
					}, {
						title: '拔枪时间',
						key: 'PluginsOutTime'
					}, {
						title: '充电开始时间',
						key: 'ChargeStartTime',
					}, {
						title: '充电结束时间',
						key: 'ChargeEndTime',
					}, {
						title: '充电时长(分钟)',
						key: 'ChargeDuration',
					}, {
						title: '减免类型',
						key: 'DerateTypeDesc',
					},
				],
				ChargeDetails: this.row.ChargeDetails,
			}
		},

		methods: {
		}
	};
</script>
